// extracted by mini-css-extract-plugin
export default {"container":"main__container__CUnq9","skyContainer":"main__skyContainer__P_L_p","showScrollArea":"main__showScrollArea__QdYwG"};